import styled from "styled-components";

const Container = styled.div`
    background: #E7EAEB;
    width: 100%;
    height: 100vh;
`;

const ContentContainer = styled.div`
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    background: white;
    max-height: calc(100vh - 150px);
    overflow-y: hidden;
    margin-top: 32px;
    border-radius: 8px;
`;

export const Styles = {
    Container,
    ContentContainer
}